import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink } from "lucide-react";

const RECRUITMENT_PLATFORMS = [
  { 
    name: "BizReach", 
    url: "https://www.bizreach.jp/",
    description: "ハイクラス転職サイト"
  },
  { 
    name: "宅建ジョブエージェント", 
    url: "https://takken-job.com/",
    description: "不動産業界専門"
  },
  { 
    name: "Indeed", 
    url: "https://jp.indeed.com/",
    description: "総合求人サイト"
  },
];

export default function ContactPage() {
  useEffect(() => {
    document.title = "お問い合わせ | ACOE 採用サイト";
  }, []);

  return (
    <div data-testid="contact-page">
      {/* ─── HERO ─── */}
      <section className="pt-32 md:pt-40 pb-20 md:pb-28 bg-acoe-charcoal" data-testid="contact-hero">
        <div className="max-w-[1400px] mx-auto px-6 md:px-12">
          <p className="text-sm tracking-[0.25em] uppercase text-acoe-gold font-heading font-semibold mb-6">Contact</p>
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.15]">
            お問い合わせ
          </h1>
          <p className="mt-6 text-white/60 text-base md:text-lg max-w-2xl leading-relaxed">
            ACOEへのご応募・お問い合わせについて
          </p>
        </div>
      </section>

      {/* ─── MESSAGE ─── */}
      <section className="py-20 md:py-32 bg-acoe-bg" data-testid="contact-message-section">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <div className="bg-white border border-acoe-border p-8 md:p-12">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-acoe-charcoal mb-6">
              採用プラットフォームからのお問い合わせ
            </h2>
            
            <div className="space-y-4 text-acoe-text leading-relaxed mb-10">
              <p>
                ACOEの採用に関するお問い合わせは、各採用プラットフォームを通じてお願いしております。
              </p>
              <p>
                以下のいずれかのサービスからACOE（株式会社セイライグループジャパン）を検索し、
                メッセージをお送りください。
              </p>
            </div>

            {/* Recruitment Platforms */}
            <div className="space-y-4 mb-10">
              <p className="text-sm tracking-[0.15em] uppercase text-acoe-muted font-heading font-semibold">
                ご利用いただける採用プラットフォーム
              </p>
              <div className="grid gap-4">
                {RECRUITMENT_PLATFORMS.map((platform) => (
                  <a
                    key={platform.name}
                    href={platform.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center justify-between p-4 border border-acoe-border hover:border-acoe-charcoal hover:bg-acoe-paper transition-all group"
                    data-testid={`platform-${platform.name.toLowerCase()}`}
                  >
                    <div>
                      <p className="font-heading font-semibold text-acoe-charcoal group-hover:text-acoe-gold transition-colors">
                        {platform.name}
                      </p>
                      <p className="text-sm text-acoe-muted">{platform.description}</p>
                    </div>
                    <ExternalLink size={18} className="text-acoe-muted group-hover:text-acoe-charcoal transition-colors" strokeWidth={1.5} />
                  </a>
                ))}
              </div>
            </div>

            {/* Note */}
            <div className="bg-acoe-paper border-l-4 border-acoe-gold p-6 mb-6">
              <p className="text-sm text-acoe-text leading-relaxed">
                <span className="font-heading font-semibold text-acoe-charcoal">ご注意：</span>
                採用プラットフォームの規約により、本サイトでの直接のお問い合わせフォームは
                ご用意しておりません。お手数をおかけしますが、上記プラットフォームをご利用ください。
              </p>
            </div>

            {/* Email contact */}
            <div className="bg-acoe-charcoal/5 border border-acoe-border p-6">
              <p className="text-sm text-acoe-text leading-relaxed">
                <span className="font-heading font-semibold text-acoe-charcoal">応募に関するご質問：</span>
                採用プラットフォームからの応募方法についてご不明な点がございましたら、
                <a 
                  href="mailto:office@seiraigroup.com" 
                  className="text-acoe-gold hover:underline font-semibold"
                >
                  office@seiraigroup.com
                </a>
                までお気軽にお問い合わせください。
              </p>
            </div>
          </div>

          {/* Back link */}
          <div className="mt-8 text-center">
            <Link
              to="/recruit"
              className="inline-flex items-center gap-2 text-acoe-charcoal font-heading font-semibold hover:text-acoe-gold transition-colors"
            >
              <ArrowLeft size={18} strokeWidth={1.5} />
              トップに戻る
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
